export default {
  init() {
    // JavaScript to be fired
    $(document).on('click', '[data-toggle="dropdown"]', function(e) {
      e.preventDefault();

      const thisDropdownToggle = $(this);
      const dropdownMenu = thisDropdownToggle.parent().find('.dropdown-menu');

      if (dropdownMenu.length) {
        dropdownMenu.toggleClass('show');
      }
    });
  },
  finalize() {
    // JavaScript to be fired, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/components/dropdowns.js